import { makeStyles } from '@material-ui/core/styles'
import tabStyles from 'global/theme/tabStyles'

export default makeStyles(theme => {
  return {
    ...tabStyles(theme)
  }
})
